module.exports = __webpack_public_path__ + "static/media/exercise_regularly.80dbc09e.svg";